import {
  NO_SORTING,
  SORT_ASCENDING,
  SORT_DESCENDING,
  TableHeader,
} from 'spa/components/table_header'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './styles'

export function Table({
  children,
  className,
  columns = [],
  headerClassName,
  onHeaderClick = [],
  sort = [],
  sticky = false,
}) {
  const headers = columns.map((columnHeader, i) => (
    <TableHeader
      className={headerClassName}
      key={i}
      onClick={onHeaderClick[i]}
      sort={sort[i]}
      sticky={sticky}
    >
      {columnHeader}
    </TableHeader>
  ))

  return (
    <div className={classNames(styles.table, className)}>
      {headers}
      {children}
    </div>
  )
}

Table.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.node),
  headerClassName: PropTypes.string,
  onHeaderClick: PropTypes.arrayOf(PropTypes.func),
  sort: PropTypes.arrayOf(
    PropTypes.oneOf([NO_SORTING, SORT_ASCENDING, SORT_DESCENDING])
  ),
  sticky: PropTypes.bool,
}
